import common from './common.json';
import documentAgreement from './documentAgreement.json';
import visitDetails from './visitDetails.json';
import languageSelector from './languageSelector.json';

export const es = {
  common,
  documentAgreement,
  languageSelector,
  visitDetails,
};
